import { render, staticRenderFns } from "./OrganizationCenter.vue?vue&type=template&id=dcd3d2de&scoped=true"
import script from "./OrganizationCenter.vue?vue&type=script&lang=js"
export * from "./OrganizationCenter.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCenter.vue?vue&type=style&index=0&id=dcd3d2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd3d2de",
  null
  
)

export default component.exports